import { ARRAY } from '@/plugins/sdk/fields'
import remove from 'lodash/remove'
import isPlainObject from 'lodash/isPlainObject'

export default class extends ARRAY {
  constructor (resource) {
    super()

    Object.defineProperties(this, {
      _resource: {
        configurable: false,
        enumerable: false,
        value: resource,
        writable: false
      }
    })
  }

  static name = 'collection'

  /** @inheritdoc */
  get modified () {
    let modified = super.modified

    for (let resource of this.current) {
      if (modified) {
        break
      }

      modified = !!resource.modified
    }

    return modified
  }

  /** @inheritdoc */
  accessor (value) {
    value = ARRAY
      .prototype
      .accessor
      .call(
        this,
        value
      )

    remove(value, (v) => {
      return !(v instanceof this._resource)
    })

    return value
  }

  /** @inheritdoc */
  mutator (value) {
    value = ARRAY
      .prototype
      .accessor
      .call(
        this,
        value
      )

    return value
      .map(v => {
        if (v instanceof this._resource) {
          return v.clone()
        } else {
          const resource = new this._resource()

          if (isPlainObject(v)) {
            resource.fill(v, !!v[resource.constructor.identifier])
          }

          return resource
        }
      })
  }

  /** @inheritdoc */
  reset () {
    this._current = this.default.map(resource => resource.clone())
  }

  /** @inheritdoc */
  copy () {
    return this
      .current
      .map(resource => resource.replicate())
  }
}
